module.exports = __webpack_public_path__ + "img/body-scanner-icon.9e5568f9.svg";